export default {
  firstName: {
    empty: 'Please enter your first name.',
    containsEmoji: `Please remove any ‘special’ characters (like emojis) to save this folder`,
  },
  lastName: {
    empty: 'Please enter your surname.',
    containsEmoji: `Please remove any ‘special’ characters (like emojis) to save this folder`,
  },
  email: {
    empty: 'Please enter your email.',
    invalidFormat: 'Please enter a valid email address.',
    containsEmoji: `Please remove any ‘special’ characters (like emojis) to save this folder`,
  },
  confirmEmail: {
    empty: 'Please confirm your email.',
    mismatch: "The values entered don't appear to match. Please check and try again.",
  },
  password: {
    empty: 'Please enter your password.',
    tooShort:
      'The value entered is too short. Please enter a value that is at least 8 characters long.',
    containsSpaces: 'Passwords may not include a space.',
  },
  confirmPassword: {
    empty: 'Please confirm your password.',
    mismatch: "The values entered don't appear to match. Please check and try again.",
    tooShort:
      'The value entered is too short. Please enter a value that is at least 8 characters long.',
  },
};
